import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedLayout from "../Layouts/ProtectedLayout";
import PublicLayout from "../Layouts/PublicLayout";
import { NotFound } from "../pages/NotFound";
import { private_route, public_routes } from "../utils/constants.js";
import { useSelector } from "react-redux";

const Navigation = () => {
  const user = useSelector((state) => state.authInfo.user);
  const filteredSideBarData = private_route.filter((item) =>
    item.role.includes(user?.user_type)
  );
  return (
    <div>
      <Routes>
        {/* Public Routes */}
        {public_routes?.map((item, index) => (
          <Route
            key={index}
            path={item.route}
            element={
              <PublicLayout
                bg_image={item.bg_image}
                heading={item.heading}
                description={item.description}
                children={item.component}
                hasBackButton={item?.hasBackButton}
              />
            }
          />
        ))}

        {/* Private Routes */}
        {filteredSideBarData?.map((item, index) => (
          <Route
            key={index}
            path={item.route}
            element={<ProtectedLayout children={item.component} />}
          />
        ))}
        {/* <Route
          path={WEB_ROUTES.dashboard}
          element={<ProtectedLayout children={<DashBoard />} />}
        />
        <Route
          path={WEB_ROUTES.staff}
          element={<ProtectedLayout children={<StaffManagement />} />}
        />
        <Route
          path={WEB_ROUTES.patient}
          element={<ProtectedLayout children={<PatientsManagement />} />}
        />
        <Route
          path={WEB_ROUTES.task}
          element={<ProtectedLayout children={<TaskManagement />} />}
        />
        <Route
          path={WEB_ROUTES.appointment}
          element={<ProtectedLayout children={<AppointmentManagement />} />}
        />

        <Route
          path={WEB_ROUTES.billing}
          element={<ProtectedLayout children={<BillingManagement />} />}
        />
        <Route
          path={WEB_ROUTES.settings}
          element={<ProtectedLayout children={<Settings />} />}
        />

        <Route
          path={WEB_ROUTES.staffattendance}
          element={<ProtectedLayout children={<StaffAttendanceManagement />} />}
        /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Navigation;
